export default __webpack_public_path__ + "static/media/mint-bg.73e665ca.png";